// =========================================================
// * Vuetify Material Dashboard - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import i18n from '@/plugins/i18n'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSweetAlert from 'vue-sweetalert'
import 'vue-tree-halower/dist/halower-tree.min.css'
import {VTree, VSelectTree} from 'vue-tree-halower'
import FlagIcon from 'vue-flag-icon'
import VueBarcode from 'vue-barcode'
import VueQrcode from 'vue-qrcode'
import * as VueGoogleMaps from 'vue2-google-maps'
// import * as socketio from 'socket.io-client'
// import VueSocketIO from 'vue-socket.io'
import VueDragDrop from 'vue-drag-drop'
import Vue2Editor from 'vue2-editor'
import VueHtmlToPaper from 'vue-html-to-paper'
import VuetifyMoney from 'vuetify-money'
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment'
import '@mdi/font/css/materialdesignicons.min.css'
import VueToastify from 'vue-toastify'
import VIdle from 'v-idle'
import './assets/css/main.css'
import './assets/css/vuetify-custom.css'
Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(VueSweetAlert)
const swal = Vue.prototype.$swal
const swalWithTimerCatch = function (...args) {
  const result = swal.apply(this, args)
  if (result && typeof result.catch === 'function') {
    return result.catch(reason => {
      if (reason === 'timer') {
        return { dismiss: 'timer' }
      }
      throw reason
    })
  }
  return result
}
Object.keys(swal).forEach(key => {
  swalWithTimerCatch[key] = swal[key]
})
Vue.prototype.$swal = swalWithTimerCatch
Vue.use(VTree)
Vue.use(VSelectTree)
Vue.use(FlagIcon)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCMk5tLxeWdPMIgyC2fU8AjnnF2WOjoIBI',
    libraries: 'places',
  },
  installComponents: true
})

Vue.use(VueDragDrop)
Vue.use(Vue2Editor)
Vue.use(VuetifyMoney)
Vue.use(VueApexCharts)
/* Vue.use(moment) */
Vue.prototype.$moment = moment

Vue.filter('formatDate', function (value, format) {
  if (value) {
    return moment(String(value)).format(format)
  }
})

Vue.component('barcode', VueBarcode)
Vue.component('qrcode', VueQrcode)
Vue.component('apexchart', VueApexCharts)

Vue.use(VueHtmlToPaper, {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
})

Vue.use(VueToastify)
/* Vue.use(VIdle) */
Vue.component('v-idle', VIdle)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  /* GOlf 2022-12-17 close browser clear localStorage */
  /* beforeMount () {
    window.addEventListener('load', this.onLoad)
    window.addEventListener('beforeunload', this.onUnload)
  },
  beforeDestroy  () {
    window.removeEventListener('load', this.onLoad)
    window.removeEventListener('beforeunload', this.onUnload)
  },
  methods: {
    onLoad (event) {
      window.localStorage.setItem('isMySessionActive', true)
    },
    onUnload (event) {
      window.localStorage.setItem('isMySessionActive', false)
    }
  }, */
  render: (h) => h(App)
  /* GOlf 2022-12-17 close browser clear localStorage */
}).$mount('#app')
